import { useState, useEffect } from 'react';
import { hydrate } from '../../core/components/hydrate.js';
import { DashronBrand } from './DashronBrand.js';

export function MobileNav() {
	const [isOpen, setIsOpen] = useState(false);

	const toggleNav = () => {
		setIsOpen(!isOpen);
	};

	// Prevent body scroll when menu is open
	useEffect(() => {		
		if (isOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
		}

		// Cleanup function to restore scroll when component unmounts
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, [isOpen]);

	return (
		<>
			{/* Mobile Navigation Backdrop */}
			{isOpen && (
				<div 
					className="fixed inset-0 z-40 cursor-pointer bg-black/40 lg:hidden" 
					onClick={toggleNav}
					onKeyDown={(e) => e.key === 'Enter' && toggleNav()}
					role="button"
					tabIndex={0}
					aria-label="Close navigation menu"
				/>
			)}

			{/* Mobile Navigation Menu */}
			<div
				id="mobile-nav"
				className={`fixed top-0 inset-x-0 z-50 bg-[#e03168] transition-transform duration-600 ease-in-out lg:hidden ${
					isOpen ? 'translate-y-0' : '-translate-y-full pointer-events-none'
				}`}
			>
				<div className="flex flex-col space-y-4 text-center font-['Newake'] text-2xl">
					<DashronBrand id="mobile" className="header-part" />
					<a href="/hobbies/tech" className="py-2 text-white hover:text-gray-300">
						TECH
					</a>
					<a href="/projects" className="py-2 text-white hover:text-gray-300">
						PROJECTS
					</a>
					<a href="/about" className="py-2 text-white hover:text-gray-300">
						ABOUT
					</a>
				</div>
			</div>

			{/* Mobile Navigation Toggle Button */}
			<button
				id="mobile-nav-toggle"
				className="fixed z-[60] flex items-center justify-center w-10 h-10 bg-[#b35e79] border-[#3e024b] shadow-lg hover:shadow-xl active:scale-95 active:shadow-md transition-all duration-150 rounded-full bottom-2 right-2 lg:hidden cursor-pointer"
				onClick={toggleNav}
				aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
				aria-expanded={isOpen}
			>
				<span aria-hidden="true">☰</span>
				<span className="sr-only">{isOpen ? "Close" : "Menu"}</span>
			</button>
		</>
	);
}

// Add the required properties for RenderInteractive
MobileNav.ScriptName = 'MobileNav';
MobileNav.URLPath = 'dashron/components/MobileNav';

hydrate(MobileNav);
